import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './modules/auth/auth.module';
import { SetupModule } from './modules/setup/setup.module';
import { CheckoutModule } from './modules/checkout/checkout.module';
import { Checkout2Module } from './modules/checkout2/checkout2.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { AuthRoutingModule } from './modules/auth/auth-routing.module';
import { DashboardRoutingModule } from './modules/dashboard/dashboard-routing.module';

import { AppComponent } from './app.component';
import { NotFoundComponent } from './shared/components/errors/not-found/not-found.component';

import { TransacaoService} from './shared/services/transacao/transacao.service';
import { HttpInterceptService } from './shared/services/http-intercept/http-intercept.service';
import { ErrorReportingService } from './shared/services/error-reporting/error-reporting.service';
import { ConcluirCadastroModule } from './modules/concluir-cadastro/concluir-cadastro.module';
import { MeuFaturamentoModule } from './modules/faturamento/meu-faturamento.module';
import { FaturamentoComponent } from './modules/dashboard/components/minha-conta/faturamento/faturamento.component';
import { ModalDetailComponent } from './shared/components/modal-detail/modal-detail.component';
import { SharedModule } from './shared/shared.module';
import {ClientNotificationService} from './shared/services/client-notification/client-notification.service';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    HttpClientModule,
    AuthModule,
    DashboardModule,
    SetupModule,
    ConcluirCadastroModule,
    CheckoutModule,
    Checkout2Module,
    AuthRoutingModule,
    DashboardRoutingModule,
    MeuFaturamentoModule,
    AppRoutingModule,
  ],
  providers: [
    TransacaoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptService,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: ErrorReportingService
    }
  ],
  bootstrap: [ AppComponent ],
})
export class AppModule { }
